(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', (event) => { const button = event.target.closest('.thumb[data-preview-src]'); if (!button) return; const main = button.closest('.product-media').querySelector('#ProductMainImage'); main.src = button.dataset.previewSrc; main.alt = button.dataset.previewAlt; });

  } catch(e) { console.error(e); }
})();
})();
